/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import { InputText } from 'primereact/inputtext'
import { Paginator } from 'primereact/paginator'
import { Card } from 'primereact/card'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

import back from '../assets/images/back.svg'
import warning from '../assets/images/warning.svg'
import { ProgressSpinner } from 'primereact/progressspinner'
import { userActions } from '../_actions'

export default function ManageExchangeComponent({ exchangeList, getExchangeByPage, totalRecords, deleteExchange,
  deleteZeroValueCompanyByExchange, getZeroValueCompanyByExchange, deleteZeroValueMessage, zeroValueList, isExchangeLoading, isExchangeZeroLoading }) {
  const [exchangeData, setExchangeData] = useState([])
  const [search, setSearch] = useState('')
  const [first, setFirst] = useState(0)
  const [page, setPage] = useState(0)
  const [pageSize] = useState(10)
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false)
  const [isDeleteZeroDialogVisible, setIsDeleteZeroDialogVisible] = useState(false)
  const [isZeroViewDialogVisible, setIsZeroViewDialogVisible] = useState(false)
  const [deleteRow, setDeleteRow] = useState(false)
  const [deleteZeroRow, setDeleteZeroRow] = useState(false)


  const history = useHistory()
  useEffect(() => {
    const exchangeArray = []
    for (let i = 0; i < exchangeList.length; i++) {
      const exchange = exchangeList[i]
      exchangeArray.push({
        'exchangename': exchange.name, 'exchangeId': exchange.exchangeId, 'company': exchange.companyCount > 0 ? <a href={'/dashboard/company-list/exchange/' + exchange.exchangeId}> {exchange.companyCount} </a> : '0', 'action': ''
      })
    } setExchangeData(exchangeArray)

  }, [exchangeList])

  useEffect(() => {
    if (search === '') {
      searchByName()
    }
  }, [search])
  useEffect(() => {
    if (deleteZeroValueMessage) {
      getExchangeByPage(page, pageSize, search)
    }
  }, [deleteZeroValueMessage])
  const editExchange = (id) => {
    history.push({
      pathname: '/dashboard/edit-exchange/' + id
    })
  }
  const actionTemplate = (rowData) => {
    return <div className="flex">
      <i className="pi pi-pencil m-r-5 pointer" title="Edit" onClick={() => { editExchange(rowData.exchangeId) }}></i>
      <i className="pi pi-trash pointer m-r-5" title="Delete" onClick={(event) => showDeleteDialog(event, rowData)}></i>
      <i className="pi pi-list pointer m-r-5" title="View Zero Market Value Companies" onClick={(event) => showZeroView(event, rowData)}></i>
      <i className="pi pi-times pointer m-r-5" title="Delete Zero Market Value Companies" onClick={(event) => showDeleteZeroDialog(event, rowData)}></i>

    </div>
  }

  function AddNewExchangeClick() {
    history.push('/dashboard/add-exchange')
  }
  const onSearchChange = (e) => {
    const { value } = e.target
    setSearch(value)
  }
  const onEnterKeySearch = (event) => {
    var code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      searchByName()
    }
  }
  const searchByName = () => {
    setFirst(0)
    getExchangeByPage(0, pageSize, search, '')
  }
  const showDeleteDialog = (event, rowData) => {
    setDeleteRow(rowData)
    setIsDeleteDialogVisible(true)
  }
  const showDeleteZeroDialog = (event, rowData) => {
    setDeleteZeroRow(rowData)
    setIsDeleteZeroDialogVisible(true)
  }
  const deleteExchangeById = () => {
    setFirst(1)
    deleteExchange(deleteRow.exchangeId, userActions.getCurrentUser())
    setIsDeleteDialogVisible(false)
  }


  const deleteZeroValueCompanyByExchangeById = () => {
    deleteZeroValueCompanyByExchange(deleteZeroRow.exchangeId)
    setIsDeleteZeroDialogVisible(false)
  }
  const showZeroView = (e, rowData) => {
    getZeroValueCompanyByExchange(rowData.exchangeId)
    setIsZeroViewDialogVisible(true)
  }

  const footer = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={() => deleteExchangeById()} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDeleteDialogVisible(false)} />
    </div>
  )
  const footerZero = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={() => deleteZeroValueCompanyByExchangeById()} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDeleteZeroDialogVisible(false)} />
    </div>
  )
  const footerZeroView = (
    <div>
      <Button label="Close" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsZeroViewDialogVisible(false)} />
    </div>
  )
  const BackClick = () => {
    history.goBack()
  }
  const onPageChange = (event) => {
    setFirst(event.first)
    setPage(event.page)
    getExchangeByPage(event.page, pageSize, search)
  }
  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="titleCon m-b-20">
            <p className="title flex">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />MANAGE EXCHANGES
            </p>
            <div className="flex">
              <div className="customBtnContainer m-r-20">
                {totalRecords > 0 && <div className="pointer m-r-10" >{totalRecords} records found</div>}
                <Button icon="pi pi-plus" onClick={AddNewExchangeClick} className="addBtnCustom" />
                <div className="pointer" onClick={AddNewExchangeClick}>Add New Exchange</div>
              </div>
              <div className="p-inputgroup customSearch">
                <InputText placeholder="Search" value={search} onChange={onSearchChange} onKeyUp={(e) => onEnterKeySearch(e)} />
                <Button icon="pi pi-search" className="p-button-warning" onClick={() => searchByName()} />
              </div>
            </div>
          </div>
          <DataTable className="manageTableHeight" dataKey="companyId" emptyMessage={isExchangeLoading ? '' : 'No Exchanges Found'} value={exchangeData} totalRecords={totalRecords} rows={pageSize} scrollable={true} responsive={true}>
            <Column key="action" field="exchangename" header="EXCHANGE NAME" />
            <Column key="action" field="company" style={{ textAlign: 'right', width: '10em' }} header="COMPANIES" />
            <Column key="action" body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} header="ACTION" />

          </DataTable>
          <div className="p-col-12 p-0">
            <Paginator first={first} rows={pageSize} scrollable={true} responsive={true} totalRecords={totalRecords} onPageChange={onPageChange}></Paginator>
          </div>
        </Card>
      </div>
      <Dialog header="Delete Exchange" footer={footer} className="custom-header" visible={isDeleteDialogVisible} style={{ width: '30vw' }} modal={true} onHide={() => setIsDeleteDialogVisible(false)}>
        <img src={warning} alt={warning} className="warn-dialog" />
        <div>Deleting this exchange will delete all the companies under this particular exchange. Do you want to proceed?</div>
      </Dialog>

      <Dialog header="Delete Zero Market Capitalization Value Companies" footer={footerZero} visible={isDeleteZeroDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsDeleteZeroDialogVisible(false)}>
        <div>Are you sure you want to delete all the zero market capitalization value companies under this exchange?</div>
      </Dialog>

      <Dialog header="View Zero Market Capitalization Value Companies" footer={footerZeroView} visible={isZeroViewDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsZeroViewDialogVisible(false)}>
        {isExchangeZeroLoading && <div className="center-pg">
          <ProgressSpinner />
        </div>}
        <div>{zeroValueList.map(c => {
          return <div key={c.companyId} className="p-col"><i className="pi pi-angle-right"></i>{c.name}</div>
        })}
          {
            (!isExchangeZeroLoading && zeroValueList?.length <= 0) ? <div>No Companies Found</div> : ''
          }
        </div>
      </Dialog>
    </div>
  )
}
ManageExchangeComponent.propTypes = {
  exchangeList: PropTypes.array,
  getExchangeByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  deleteExchange: PropTypes.func,
  deleteZeroValueCompanyByExchange: PropTypes.func,
  getZeroValueCompanyByExchange: PropTypes.func,
  zeroValueList: PropTypes.array,
  deleteZeroValueMessage: PropTypes.object,
  isExchangeLoading: PropTypes.bool,
  isExchangeZeroLoading: PropTypes.bool,
}



